export const selectOptionsRequestedLoanTermMonths = [
  // "6 months",
  "12 months",
  "18 months",
  "24 months",
];
